export default function DownloadArrowDown({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12 16L8 10.6667H10L10 5.16666H14L14 10.6667H16L12 16Z" fill="currentColor" />
      <path d="M5 17V19H19V17H5Z" fill="currentColor" />
    </svg>
  )
}
